export const getPermissions = () => {
    const permission = localStorage.getItem('permission');
    if (!permission) return {};
    try {
        return JSON.parse(permission);
    } catch (e) {
        console.error('Error parsing permissions:', e);
        return {};
    }
};
  
export const hasPermission = (resource, action) => {
    if (!resource || !action) return false;
    const permission = getPermissions();
    return Boolean(permission?.[resource]?.[action]);
};


  
